import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import "./LanguageSelector.css";

function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const languages = [
    { code: "en", label: "English", country: "US" },
    { code: "sq", label: "Albanian", country: "AL" },
    { code: "am", label: "Amharic", country: "ET" },
    { code: "ar", label: "Arabic", country: "SA" },
    { code: "az", label: "Azerbaijani", country: "AZ" },
    { code: "eu", label: "Basque", country: "ES" },
    { code: "bn", label: "Bengali", country: "IN" },
    { code: "bs", label: "Bosnian", country: "BA" },
    { code: "bg", label: "Bulgarian", country: "BG" },
    { code: "my", label: "Burmese", country: "MM" },
    { code: "ca", label: "Catalan", country: "ES" },
    { code: "zh", label: "Chinese", country: "CN" },
    { code: "hr", label: "Croatian", country: "HR" },
    { code: "cs", label: "Czech", country: "CZ" },
    { code: "da", label: "Danish", country: "DK" },
    { code: "nl", label: "Dutch", country: "NL" },
    { code: "et", label: "Estonian", country: "EE" },
    { code: "fi", label: "Finnish", country: "FI" },
    { code: "fr", label: "French", country: "FR" },
    { code: "gl", label: "Galician", country: "ES" },
    { code: "ka", label: "Georgian", country: "GE" },
    { code: "de", label: "German", country: "DE" },
    { code: "el", label: "Greek", country: "GR" },
    { code: "gu", label: "Gujarati", country: "IN" },
    { code: "he", label: "Hebrew", country: "IL" },
    { code: "hi", label: "Hindi", country: "IN" },
    { code: "hu", label: "Hungarian", country: "HU" },
    { code: "id", label: "Indonesian", country: "ID" },
    { code: "it", label: "Italian", country: "IT" },
    { code: "ja", label: "Japanese", country: "JP" },
    { code: "km", label: "Khmer", country: "KH" },
    { code: "ko", label: "Korean", country: "KR" },
    { code: "lo", label: "Lao", country: "LA" },
    { code: "lv", label: "Latvian", country: "LV" },
    { code: "lt", label: "Lithuanian", country: "LT" },
    { code: "mk", label: "Macedonian", country: "MK" },
    { code: "ms", label: "Malay", country: "MY" },
    { code: "ml", label: "Malayalam", country: "IN" },
    { code: "mn", label: "Mongolian", country: "MN" },
    // { code: "nb", label: "Norwegian Bokmål", country: "NO" },
    { code: "fa", label: "Persian", country: "IR" },
    { code: "pl", label: "Polish", country: "PL" },
    { code: "pt", label: "Portuguese", country: "PT" },
    { code: "ro", label: "Romanian", country: "RO" },
    { code: "ru", label: "Russian", country: "RU" },
    { code: "sr", label: "Serbian", country: "RS" },
    { code: "sk", label: "Slovak", country: "SK" },
    { code: "sl", label: "Slovenian", country: "SI" },
    { code: "es", label: "Spanish", country: "ES" },
    { code: "sv", label: "Swedish", country: "SE" },
    { code: "tl", label: "Tagalog", country: "PH" },
    { code: "te", label: "Telugu", country: "IN" },
    { code: "th", label: "Thai", country: "TH" },
    { code: "tr", label: "Turkish", country: "TR" },
    { code: "uk", label: "Ukrainian", country: "UA" },
    { code: "vi", label: "Vietnamese", country: "VN" },
  ];

  const currentLanguage =
    languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div className="country-nav">
      <ReactCountryFlag
        countryCode={currentLanguage.country}
        svg
        className="country-flag"
      />

      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="countries-name common-text  ftw-4 white"
      >
        {languages.map(({ code, label }) => (
          <option key={code} value={code} style={{ color: "black" }}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSelector;
